export const MOVIES = 1;
export const TVSHOW = 2;


// WEBPACK FOOTER //
// ./src/constants/TypesCategory.js